import {
  getActionNameWithStatus,
  getResetAction,
} from "../../constants/actions-methods";
import { requestStatus } from "../../constants/request";
import { serverApis } from "../../constants/server-apis";

export const warehouseListReducer = (state = [], action) => {
  const actionName = serverApis.getWarehouseList.actionName;
  switch (action.type) {
    case getActionNameWithStatus(actionName, requestStatus.SUCCESS):
      return action.json.warehouses;

    case getResetAction(actionName):
      return [];
    default:
      return state;
  }
};
